import { render, staticRenderFns } from "./CustomDialog.vue?vue&type=template&id=bf74abfe&scoped=true&"
import script from "./CustomDialog.vue?vue&type=script&lang=js&"
export * from "./CustomDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomDialog.vue?vue&type=style&index=0&id=bf74abfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf74abfe",
  null
  
)

export default component.exports